import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './ApiPage.module.scss';

import { useSelectedContext } from 'context/contextSelector';
import UnauthApi from '../components/UnauthApi';
import AuthApi from '../components/AuthApi';

const ApiPage = () => {
  const { user } = useSelectedContext((context) => context.user);
  const navigate = useNavigate();

  const openDocumentation = () => {
    navigate('decarbonizator');
  };

  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <UnauthApi openDocumentation={openDocumentation} bookbutton />
        {/* {user?.id ? (
          <AuthApi openDocumentation={openDocumentation} />
        ) : (
          <UnauthApi openDocumentation={openDocumentation} bookbutton />
        )} */}
      </div>
    </div>
  );
};

export default ApiPage;
